import React, { useEffect } from 'react';
import { Modal } from 'react-bootstrap';
// import { useTranslation } from 'react-i18next';
// import { useQuery } from 'react-query';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import {useNavigate} from "react-router-dom";
import use2FA from '../../hooks/use2FA';
import { useTimer } from '../../hooks/useTimer';
import {
  // setAuthModalContent,
  // setAuthModalContent,
  setShouldTimerStart,
  setShowAuthErrorModal,
  setShowAuthModal,
  setPaciLogin,
  setPaciErrorFlag
} from '../../reducer/utilitySlice';
// import { AUTHENTICATION_KUWAIT } from '../../services/common/endpoints';
import { isIOSDevice } from '../../services/common/CommonUtils';
import {
  getGlobalSettingValue,
  // secondsToHms,
} from '../../services/common/utils';
import Loadingcomponent from '../loader/loadingcomponent';
import MessageModal from './bottom-modal-message';
import PaciCheck from '../../pages/call-details/paciApiCheck';

const AuthModal = () => {
 const { t } = useTranslation();
  const {
    utilityData: {
      globalSetting,
      showAuthModal,
      authModalContent,
      shouldTimerStart,
      showAuthErrorModal,
      authErrorModalContent,
      showEnableMediumAuthBtn,
      showGetKuwaitAppBtn,
      isPaciLogin,
      paciErrorflag
    },
    nojoomData: { clickedTrasferPointsCardData },
    utilityData: { clicked2FAData },
    cdrData: {cdrSuccessFunCall}
  } = useSelector((state) => state);
  const dispatch = useDispatch();

  // console.log('showAuthErrorModal', showAuthErrorModal);
  const navigate = useNavigate();
  const settingsArr = globalSetting
    ? globalSetting?.Globalsettings[0]?.items[0]?.metadata
    : [];

  const time = new Date();
  const expirySeconds = isNaN(
    parseInt(getGlobalSettingValue('mobileidshowtimerlimit', settingsArr))
  )
    ? 0
    : parseInt(getGlobalSettingValue('mobileidshowtimerlimit', settingsArr));
  // time.setSeconds(time.getSeconds() + 60 * 1); // 1 minutes timer
  time.setSeconds(time.getSeconds() + expirySeconds);

  const {
    seconds,
    minutes,
    // hours,
    // days,
    isRunning,
    // start,
    pause,
    // resume,
    restart,
  } = useTimer({
    expiryTimestamp: time,
    autoStart: false,
    onExpire: () => {
      handleExpire();
    },
  });

  // const crrdata = {
  //   category: clickedTrasferPointsCardData?.displaytext,
  //   category_ar: clickedTrasferPointsCardData?.displaytext_ar,
  //   id: clickedTrasferPointsCardData?.metadata
  //     ? clickedTrasferPointsCardData?.metadata[1]?.meta_value_english
  //     : '',
  //   infotype: clickedTrasferPointsCardData?.metadata
  //     ? clickedTrasferPointsCardData?.metadata[2]?.meta_value_english
  //     : '',
  //   previewimage: clickedTrasferPointsCardData?.metadata
  //     ? clickedTrasferPointsCardData?.metadata[3]?.meta_value_english
  //     : '',
  // };

  const { getMobileIdStatus, getAuthStatus } = use2FA({
    startTimer: restart,
    pauseTimer: pause,
    isTimerRunning: isRunning,
    navigateTo: clickedTrasferPointsCardData?.redirecturl,
    navigateToState: clickedTrasferPointsCardData,
    navigateUrl: clicked2FAData?.url,
    navigateState: clicked2FAData?.state,
    successFuncCall: clicked2FAData?.successFuncCall
  });
  const isCdrVerification = useSelector(state => state?.cdrData?.isCdrVerification)
  const {getMobileIdStatusCheck, getAuthStatusCheck} = PaciCheck({
    startTimer: restart,
    successFuncCall: cdrSuccessFunCall,
    isTimerRunning: isRunning,
    pauseTimer: pause,
  })

  useEffect(()=>{
    if(isPaciLogin){
      getMobileIdStatus.refetch()
    }
  }, [isPaciLogin])

  // console.log('seconds', seconds, typeof seconds, 'minutes', minutes);

  useEffect(() => {
    if (isRunning && !isCdrVerification) {
      const interval = setInterval(() => {
        // console.log('sdsdsdsdsd===>12');
        getAuthStatus.mutate();
      }, 5000);

      return () => clearInterval(interval);
    }
    else if(isRunning && isCdrVerification){
      const interval = setInterval(() => {
        // console.log('sdsdsdsdsd===>12');
        getAuthStatusCheck.mutate();
      }, 5000);

      return () => clearInterval(interval);
    }
    //eslint-disable-next-line
  }, [isRunning]);

  // console.log('seconds.toString()', seconds.toString(), 'minutes.toString()', minutes.toString());

  // useEffect(() => {
  //   if (seconds.toString() === '0' && minutes.toString() === '0') {
  //     console.log('sdsdsdsdsd===>');
  //     getAuthStatus.mutate();
  //   }
  // }, [seconds, minutes, clickedTrasferPointsCardData]);

  const handleExpire = () => {
    if(isCdrVerification){
      setTimeout(() => {
        getAuthStatusCheck.mutate();
      }, 1000);
    }else{
      setTimeout(() => {
        getAuthStatus.mutate();
      }, 1000);
    }
  };

  const handleContinue = () => {
    if(isPaciLogin && !shouldTimerStart){
      getMobileIdStatus.refetch();
    }else if(isCdrVerification && !shouldTimerStart){
      getMobileIdStatusCheck.refetch();
    }
    else{
    if (showEnableMediumAuthBtn) {
      // console.log('showEnableMediumAuthBtn');
      // return;
      let url = '';
      if(isIOSDevice()){
        url = getGlobalSettingValue(
          'enablemediummobileidiosurl',
          settingsArr
        )
        window.open(url, '_blank');
      }else{
        url = getGlobalSettingValue(
          'enablemediummobileidandroidurl',
          settingsArr
        )
        window.open(url, '_blank');
      }
      dispatch(setShowAuthModal(false));
    } else if (showGetKuwaitAppBtn) {
      // const url = getGlobalSettingValue(
      //   'enablemediummobileidandroidurl',
      //   settingsArr
      // );
      // window.open(url, '_blank');
      // dispatch(setShowAuthModal(false));
      let url = '';
      if(isIOSDevice()){
        url = getGlobalSettingValue(
          'registermobileidiosurl',
          settingsArr
        )
        window.open(url, '_blank');
      }else{
        url = getGlobalSettingValue(
          'registermobileidandroidurl',
          settingsArr
        )
        window.open(url, '_blank');
      }
      dispatch(setShowAuthModal(false));
    } else {
      getMobileIdStatus.refetch();
    }
  }
  };

  const handleHideAuthModal = () => {
    dispatch(setShowAuthErrorModal(false));
    dispatch(setShowAuthModal(false));
    dispatch(setShouldTimerStart(false));
    dispatch(setPaciLogin(false))
    pause();
  };

  const handleCancel = () => {
    handleHideAuthModal();
    dispatch(setPaciLogin(false));
    dispatch(setPaciErrorFlag(false));
  }

  const handleOpenKuwaitApp = () => {
    let url = '';
    if(isIOSDevice()){
      url = getGlobalSettingValue(
        'paciiosstoreurl',
        settingsArr
      )
      window.open(url, '_blank');
    }else{
      url = getGlobalSettingValue(
        'paciandroidstoreurl',
        settingsArr
      )
      window.open(url, '_blank');
    }
  }


  return (
    <>
      <Modal
        show={showAuthModal}
        backdrop="true"
        className="bottom_modal animated  slideInUp faster sp16-modal-bounce-effect"
        onHide={handleHideAuthModal}
      >
        <Modal.Body className="text-center">
          <div className="modal_img mb-4">
            <img
              src={
                authModalContent.icon ||
                process.env.PUBLIC_URL + '/assets/images/Kuwait_id_popup1.png'
              }
              width={60}
              alt="modal-icon"
            />
          </div>
          <h3 className="primary_16 mb-3">{authModalContent.title}</h3>
          <p className="modal_p">{authModalContent.message}</p>
          <div className="mt-4">
            {!shouldTimerStart && (
              <>
              {paciErrorflag &&
              <button
                type="button"
                style={{marginBottom: "0.5rem"}}
                className="custom_btn custom_btn_primary_outline btn_block me-2"
                onClick={()=>{handleCancel(); navigate(-1)}}
              >
                {t('Cancel')}
              </button>}
          
              <button
                type="button"
                className="custom_btn custom_btn_primary btn_block"
                data-bs-dismiss="modal"
                onClick={handleContinue}
                disabled={
                  getMobileIdStatus.isLoading || getMobileIdStatus.isFetching || getMobileIdStatusCheck.isFetching || getMobileIdStatusCheck.isLoading
                }
              >
                {getMobileIdStatus.isLoading || getMobileIdStatus.isFetching ||getMobileIdStatusCheck.isFetching || getMobileIdStatusCheck.isLoading ? (
                  <Loadingcomponent />
                ) : (
                  authModalContent.btnText
                )}
              </button>
            </>
            )}

            {shouldTimerStart && (
              <div className="d-flex align-items-center m-auto justify-content-center">
                <div className="width25 popup-timer">
                  <img
                    src={
                      process.env.PUBLIC_URL +
                      '/assets/images/popup_timer_icon.svg'
                    }
                    className="me-2"
                    alt='timer-icon'
                  />
                </div>
                <div className="width30 me-2">
                  {isPaciLogin ? 
                    <label id="timer" className="popup_timer">
                     {minutes < 10 ? `${minutes}` : minutes}:
                     {seconds < 10 ? `0${seconds}` : seconds}
                    </label> : 
                    <label id="timer" className="popup_timer">
                      {minutes < 10 ? `0${minutes}` : minutes}:
                      {seconds < 10 ? `0${seconds}` : seconds}
                    </label>
                  }
                </div>
              </div>
            )}

              {shouldTimerStart && (
              <div style={{display: 'flex', flexDirection: 'column', gap: '0.5rem', marginTop: '1rem'}}>
                <button
                  type="button"
                  className="custom_btn custom_btn_primary_outline btn_block me-2"
                  onClick={handleCancel}
                >
                  {t('Cancel')}
                </button>

                <button
                  type="button"
                  className="custom_btn custom_btn_primary btn_block"
                  onClick={handleOpenKuwaitApp}
                >
                 {isCdrVerification ? authModalContent.btnText : getGlobalSettingValue('kuwaitMobile', settingsArr)}
                </button>
              </div>
            )}

          </div>
        </Modal.Body>
      </Modal>

      <MessageModal
        type="2"
        show={showAuthErrorModal}
        message={authErrorModalContent.message}
        handleOk={() => dispatch(setShowAuthErrorModal(false))}
      />
    </>
  );
};
export default AuthModal;
